import {RouteObject} from "react-router";
import {ProtectedLayout, PublicLayout} from "../../components/layout/Layout";
import {ROUTE_PATH} from "../constants";
import {
  ArticlesPage,
  AuthPage,
  MainPage,
  ScreeningPage,
  SpecialistsPage,
  RegisterPage,
  RegisterVerification,
  RegisterConfirm,
  RestoreConfirm,
  RestorePassword,
  GameCategory,
  CurrentGame, TestProcessingPage
} from "../../pages";
import { CurrentCard } from "../../pages/MaterialsTrainingCards/[cardCategory]/[currentCard]";
import {KindergartenListPage} from "../../pages/KindergartenList";
import ArticleDetailsPage from "../../pages/Articles/ArticleDetailsPage";
import AuthorArticlesPage from "../../pages/Articles/AuthorArticlesPage";
import {RootLayout} from "../../components/layout";
import {NotFoundPage} from "../../pages/NotFound";
import { MaterialsPage } from "../../pages/MaterialsPage";
import { MaterialsDetailPage } from "../../pages/MaterialsDetail";
import { MainVideoPage } from "../../pages/MainVideos";
import {TestsListPage} from "../../pages/Screening/testsList";
import { TestsListEarlyPage } from "../../pages/ScreeningEarly/testsList";
import {SelectedTestIdPage} from "../../pages/Screening/testsList/[age]/[testId]";
import { SelectedEarlyTestIdPage } from "../../pages/ScreeningEarly/testsList/[testId]";
import { SelectedEarlyTestIdPageRoutines } from "../../pages/ScreeningEarly/testsList/[testId]/[age]";
import { SelectedScreeningTestIdPage } from "../../pages/Screening/testsList/[age]";
import { SelectedScreeningIdPageRoutines } from "../../pages/Screening/testsList/[age]/[testProcessing]";
import { ProfilePage } from "../../pages/Profile";
import { MyConsultations } from "../../pages/MyConsultations";
import { ResultsPage } from "../../pages/Results";
import { TestsListNeuroPage } from "../../pages/ScreeningNeuro/testsList";
import { SelectedNeuroTestIdPage } from "../../pages/ScreeningNeuro/testsList/[testId]";
import { SelectedNeuroTestIdPageRoutines } from "../../pages/ScreeningNeuro/testsList/[testId]/[age]";
import { TestNeuroProcessingPage } from "../../pages/ScreeningNeuro/testsList/[testId]/[age]/[testProcessing]";
import { PrivacyPolicyPage } from "../../pages/PrivacyPolicy";
import { UserAgreementPage } from "../../pages/UserAgreement";
import { UserAgreementPageKz } from "../../pages/UserAgreement/kk";
import { RestorePageComponent } from "../../pages";
import { ResultsConsultationPage } from "../../pages/ResultsConsultation";
import { CardCategory } from "../../pages/MaterialsTrainingCards/[cardCategory]";
import { AudioTales } from "../../pages/AudioTales";
import { PsychoSupportPage } from "../../pages/PsychoSupport";
import { CurrentPsychoPage } from "../../pages/PsychoSupport/[supportId]";
import { CurrentCategoryPsychoPage } from "../../pages/PsychoSupport/[supportId]/[categoryId]";
import { TestsReadinessListPage } from "../../pages/ScreeningReadiness/testsList";
import { SelectedScreeningReadinessIdPageRoutines } from "../../pages/ScreeningReadiness/testsList/[age]/[testProcessing]";
import { SelectedScreeningReadinessTestIdPage } from "../../pages/ScreeningReadiness/testsList/[age]";
import { SelectedTestReadinessIdPage } from "../../pages/ScreeningReadiness/testsList/[age]/[testId]";
import { ExpiredPasswordPage } from "../../pages/ExpiredPassword";
import {MarathonLandingPage} from "../../pages/MarathonLanding";
import {MarathonDiagnosticsPage} from "../../pages/MarathonDiagnostics";
import { MarathonSpeechPage } from "../../pages/MarathonSpeech";

const publicRoutesArr: RouteObject[] = [
  {
    element: <PublicLayout/>,
    children: [
      {
        path: ROUTE_PATH.AUTH,
        element: <AuthPage/>,
      },
      {
        path: ROUTE_PATH.RESTORE_PAGE,
        element: <RestorePageComponent/>,
      },
      {
        path: ROUTE_PATH.RESTORE_CONFIRM,
        element: <RestoreConfirm/>,
      },
      {
        path: ROUTE_PATH.RESTORE_AUTH,
        element: <RestorePassword/>,
      },
      {
        path: ROUTE_PATH.REGISTER,
        element: <RegisterPage/>,
      },
      {
        path: ROUTE_PATH.EXPIRED,
        element: <ExpiredPasswordPage/>,
      },
      {
        path: ROUTE_PATH.REGISTER_VERIFICATION,
        element: <RegisterVerification/>,
      },
      {
        path: ROUTE_PATH.REGISTER_CONFIRM,
        element: <RegisterConfirm/>,
      },
    ],
  },
]

const protectedRoutesArr: RouteObject[] = [
  {
    element: <ProtectedLayout/>,
    children: [
      {
        path: ROUTE_PATH.MAIN,
        element: <MainPage/>,
      },
      {
        path: ROUTE_PATH.MARATHON_LANDING,
        element: <MarathonLandingPage/>,
      },
      {
        path: ROUTE_PATH.MARATHON_DIAGNOSTICS,
        element: <MarathonDiagnosticsPage/>,
      },
      {
        path: ROUTE_PATH.MARATHON_SPEECH,
        element: <MarathonSpeechPage/>,
      },
      {
        path: ROUTE_PATH.KINDERGARTEN_LIST,
        element: <KindergartenListPage/>,
      },
      {
        path: ROUTE_PATH.PROFILE,
        element: <ProfilePage/>,
      },
      {
        path: ROUTE_PATH.PRIVACY_POLICY,
        element: <PrivacyPolicyPage/>,
      },
      {
        path: ROUTE_PATH.USER_AGREEMENT,
        element: <UserAgreementPage />,
      },
      {
        path: ROUTE_PATH.RESULTS,
        element: <ResultsPage/>,
      },
      {
        path: ROUTE_PATH.RESULTS_CONSULTATION,
        element: <ResultsConsultationPage/>,
      },
      {
        path: ROUTE_PATH.MY_CONSULTATIONS,
        element: < MyConsultations/>,
      },
      {
        path: ROUTE_PATH.MAIN_VIDEO,
        element: <MainVideoPage/>,
      },
      {
        path: ROUTE_PATH.ARTICLES,
        element: <ArticlesPage/>,
      },
      {
            path: ROUTE_PATH.PSYCHO_PED_SUPPORT,
            children: [
              {
                element: <PsychoSupportPage/>,
                index: true
              },
              {
                path: ROUTE_PATH.CURRENT_PSYCHO,
                children: [
                  {
                    element:<CurrentPsychoPage/>,
                    index: true
                  }
                ]
              },
              {
                path: ROUTE_PATH.CURRENT_PSYCHO_DETAIL,
                children: [
                  {
                    element:<CurrentCategoryPsychoPage/>,
                    index: true
                  }
                ]
              },
            ]
          },
      {
        path: ROUTE_PATH.ARTICLES_DETAILS,
        element: <ArticleDetailsPage />,
      },
      {
        path: ROUTE_PATH.ARTICLES_AUTHORS,
        element: <AuthorArticlesPage />,
      },
      {
        path: ROUTE_PATH.SCREENING,
        children: [
          {
            element: <ScreeningPage/>,
            index: true,
          },
          {
            path: ROUTE_PATH.SCREENING_TESTS_LIST,
            children: [
              {
                element: <TestsListPage/>,
                index: true
              },
              // {
              //   path: ROUTE_PATH.SCREENING_CURRENT_TEST,
              //   children: [
              //     {
              //       element:<SelectedTestIdPage/>,
              //       index: true
              //     }
              //   ]
              // },
              {
                path: ROUTE_PATH.SCREENING_CURRENT_TEST_WITH_AGE,
                children: [
                  {
                    element:<SelectedScreeningIdPageRoutines/>,
                    index: true
                  }
                ]
              },
              {
                path: ROUTE_PATH.SCREENING_CURRENT_TEST_WITH_AGE_PROCESSING,
                children: [
                  {
                    element:<SelectedTestIdPage/>,
                    index: true
                  }
                ]
              },
              {
                path: ROUTE_PATH.SCREENING_CURRENT_TEST,
                children: [
                  {
                    element:<SelectedScreeningTestIdPage/>,
                    index: true
                  }
                ]
              },
            ]
          },
          
          {
            path: ROUTE_PATH.SCREENING_READINESS_TESTS_LIST,
            children: [
              {
                element: <TestsReadinessListPage/>,
                index: true
              },
              // {
              //   path: ROUTE_PATH.SCREENING_CURRENT_TEST,
              //   children: [
              //     {
              //       element:<SelectedTestIdPage/>,
              //       index: true
              //     }
              //   ]
              // },
              {
                path: ROUTE_PATH.SCREENING_READINESS_CURRENT_TEST_WITH_AGE,
                children: [
                  {
                    element:<SelectedScreeningReadinessIdPageRoutines/>,
                    index: true
                  }
                ]
              },
              {
                path: ROUTE_PATH.SCREENING_READINESS_CURRENT_TEST_WITH_AGE_PROCESSING,
                children: [
                  {
                    element:<SelectedTestReadinessIdPage/>,
                    index: true
                  }
                ]
              },
              {
                path: ROUTE_PATH.SCREENING_READINESS_CURRENT_TEST,
                children: [
                  {
                    element:<SelectedScreeningReadinessTestIdPage/>,
                    index: true
                  }
                ]
              },
            ]
          },

          {
            path: ROUTE_PATH.SCREENING_TESTS_LIST_EARLY,
            children: [
              {
                element: <TestsListEarlyPage/>,
                index: true
              },
              {
                path: ROUTE_PATH.SCREENING_CURRENT_TEST_EARLY,
                children: [
                  {
                    element:<SelectedEarlyTestIdPage/>,
                    index: true
                  }
                ]
              },
              {
                path: ROUTE_PATH.SCREENING_CURRENT_TEST_EARLY_WITH_AGE,
                children: [
                  {
                    element:<SelectedEarlyTestIdPageRoutines/>,
                    index: true
                  },
                  {
                    path: ROUTE_PATH.SCREENING_CURRENT_TEST_EARLY_WITH_AGE_PROCESSING,
                    children: [
                      {
                        element: <TestProcessingPage/>,
                        index: true
                      }
                    ]
                  }
                ]
              },
            ]
          },
          {
            path: ROUTE_PATH.SCREENING_NEURO,
            children: [
              {
                element: <TestsListNeuroPage/>,
                index: true
              },
              {
                path: ROUTE_PATH.SCREENING_CURRENT_NEURO,
                children: [
                  {
                    element:<SelectedNeuroTestIdPage/>,
                    index: true
                  }
                ]
              },
              {
                path: ROUTE_PATH.SCREENING_CURRENT_NEURO_WITH_AGE,
                children: [
                  {
                    element:<SelectedNeuroTestIdPageRoutines/>,
                    index: true
                  },
                  {
                    path: ROUTE_PATH.SCREENING_CURRENT_NEURO_WITH_AGE_PROCESSING,
                    children: [
                      {
                        element: <TestNeuroProcessingPage/>,
                        index: true
                      }
                    ]
                  }
                ]
              }
            ]
          }

        ]
      },
      {
        path: ROUTE_PATH.SPECIALISTS,
        children: [
          {
            element: <SpecialistsPage/>,
            index: true,
          }
        ]
      },
      {
        path: ROUTE_PATH.MATERIALS_EARLY,
        children: [
          {
            element: <MaterialsPage/>,
            index: true,
          }
        ]
      },
      {
        path: ROUTE_PATH.MATERIALS_PRESCHOOL,
        children: [
          {
            element: <MaterialsPage />,
            index: true,
          }
        ]
      },
      {
            path: ROUTE_PATH.TRAINING_CARDS,
            children: [
              {
                element: <CardCategory/>,
                index: true
              },
              {
                path: ROUTE_PATH.CURRENT_CARD,
                children: [
                  {
                    element:<CurrentCard/>,
                    index: true
                  }
                ]
              },
            ]
          },
          {
            path: ROUTE_PATH.AUDIO_TALES,
            children: [
              {
                element: <AudioTales />,
                index: true,
              }
            ]
          },
      {
        path: ROUTE_PATH.MATERIALS_DETAIL,
        children: [
          {
            element: <MaterialsDetailPage/>,
            index: true,
          },
          {
            path: ROUTE_PATH.GAMES_LIST,
            children: [
              {
                element: <GameCategory/>,
                index: true
              },
              {
                path: ROUTE_PATH.CURRENT_GAME,
                children: [
                  {
                    element:<CurrentGame/>,
                    index: true
                  }
                ]
              },
            ]
          }
        ]
      },

    ],
  },
]

export const ROUTES_CONFIG: RouteObject[] = [
  {
    element: <RootLayout/>,
    errorElement: <NotFoundPage />,
    loader: async ({params}) => {
      return null
    },
    action: async ({params, request}) => {
      return null
    },
    children: [
      ...publicRoutesArr,
      ...protectedRoutesArr,
    ]
  }
]